module.exports = __webpack_public_path__ + "static/media/frozen1.ebe33666.png";